export const USER_INFO = 'USER_INFO';
export const JOB_HIRE_ARRS = 'JOB_HIRE_ARRS';